import type { Decorator } from 'final-form';

import { useDecorator } from './utils';

export const useHashFocus = (
    hash?: string,
    enabled?: boolean
): Decorator<Record<string, unknown>> =>
    useDecorator(form => {
        if (!hash || !enabled) return () => {};
        const manuallyNavigateAndFocus = (event: MouseEvent) => {
            if (!hash || typeof event.composedPath !== 'function') return;

            const path = event.composedPath() as Element[];

            if (!path.some(element => element.getAttribute?.('href') === `#${hash}`)) return;

            // Без этого после фокуса вызывается popstate, который вызывает блур инпута
            event.preventDefault();
            window.location.hash = hash;
            form.mutators.onComplete();
        };

        window.addEventListener('click', manuallyNavigateAndFocus, false);

        return () => {
            window.removeEventListener('click', manuallyNavigateAndFocus, false);
        };
    });
